<template>
    <div>
        <RejillaInstalaciones :dxDataSourceProp="dxDataGridSource"></RejillaInstalaciones>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute } from "vue-router";
import { useIntl } from '@services/i18n'
import type { LoadOptions } from 'devextreme/data';
import { useApi } from '@/.shared/.api/integration';
import type { InstalacionDetalleModel } from '@/.shared/.api';
import type CustomStore from 'devextreme/data/custom_store';
import { useRouter } from '@/.shared/services/routing-services';
import RejillaInstalaciones from '@/components/instalaciones/RejillaInstalaciones.vue';
import type { LoadResult, LoadResultObject } from 'devextreme/common/data/custom-store';
const emit = defineEmits(['childViewLoaded']);

const api = useApi();
const intl = useIntl();
const route = useRoute();
const router = useRouter();

let dxDataGridSource: CustomStore;
const instalaciones = ref<InstalacionDetalleModel[]>([]);

onMounted(() => {
    emit('childViewLoaded', route.name);
});

dxDataGridSource = api.apiStore({ // para rejillas
    key: 'Id',
    load: await api.toStandardApiFunction('instalacionGetRejilla', {}),
    onLoaded: (result: LoadResult<InstalacionDetalleModel>, loadOptions: LoadOptions<InstalacionDetalleModel>) => {
        if (loadOptions.group == null) {
            instalaciones.value = (result as LoadResultObject<InstalacionDetalleModel>).data as InstalacionDetalleModel[];
        }
    }
});
</script>